// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"325":"56c40c73","453":"f4625352","585":"f05254b4","600":"45c24112","925":"ca55f13d"}[chunkId] + ".chunk.js";
};